<div class="ssik-extra-metro-product-detail" :class="currentDeviceViewClass">
    <slot name="left"></slot>
    <slot name="right"></slot>
</div>